<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";

export default {
  name: "InitiativeCategories",
  data() {
    return {
      loading: false,
      dataList: [],
      totalElements: 0,
      totalPages: null,
      size: 15,
      page: 1,
      // Status filtri (tri-state): "" = hammasi, "1" = faqat faol, "0" = faqat nofaol
      isActiveFilter: "",
    }
  },
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    }
  },
  methods: {
    handleSizeChange(val) {
      this.page = 1;
      this.$router
          .replace({
            query: {...this.$route.query, size: val},
          })
          .then(() => {
            this.getCategories();
          })
          .catch(() => {
          });
    },
    handleCurrentChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, page: val},
          })
          .then(() => {
            this.getCategories();
          })
          .catch(() => {
          });
    },
    onChangeStatus() {
      // Filtr o'zgarsa paginatsiya 1-betga qaytadi
      this.page = 1;
      this.$router
          .replace({
            query: {...this.$route.query, page: 1},
          })
          .then(() => {
            this.getCategories();
          })
          .catch(() => {
          });
    },
    onClickDelete(id) {
      ElMessageBox.confirm("Ma'lumotni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`/api/v1/initiative-categories/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Turkum o'chirildi",
                  });
                  this.getCategories();
                })
                .catch((error) => {
                  // Ishlatilayotgan turkumni o'chirib bo'lmaydi (FK -> 500)
                  const status = error?.response?.status;
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message:
                        status === 500
                            ? "Bu turkum ishlatilmoqda, o'chirib bo'lmaydi. O'rniga uni nofaol qiling"
                            : status === 404
                                ? "Turkum topilmadi"
                                : "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },
    getCategories() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size
          ? parseInt(this.$route.query.size || "")
          : this.size;

      const params = {
        limit: this.size,
        offset: (this.page - 1) * this.size,
      };
      // Tri-state: faqat "1"/"0" yuboriladi, "hammasi" da param umuman yuborilmaydi
      if (this.isActiveFilter === "1" || this.isActiveFilter === "0") {
        params.is_active = this.isActiveFilter;
      }

      this.$http
          .get(`api/v1/initiative-categories`, {params})
          .then(({data}) => {
            this.dataList = data.initiative_categories;
            this.totalElements = data.count;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    indexMethod(index) {
      return index + (this.page - 1) * this.size + 1
    }
  },
  mounted() {
    this.getCategories();
  }
}
</script>

<template>
  <div class="initiative-categories" v-loading.fullscreen="loading">
    <div class="header">
      <div class="filters">
        <el-select
            v-model="isActiveFilter"
            placeholder="Holati bo'yicha"
            style="width: 200px"
            @change="onChangeStatus"
        >
          <el-option label="Hammasi" value=""/>
          <el-option label="Faqat faol" value="1"/>
          <el-option label="Faqat nofaol" value="0"/>
        </el-select>
      </div>
      <div style="display: flex;gap:5px">
        <router-link to="initiative-category/add" class="el-button el-button--primary">
          Qo'shish
        </router-link>
      </div>
    </div>
    <el-table
        :data="dataList"
        class="table"
        border
        height="calc(100vh - 235px)"
    >
      <el-table-column type="index" :index="indexMethod" width="50" label="#"/>
      <el-table-column prop="title" label="Nomi" min-width="280"/>
      <el-table-column label="Jihozlanadimi" width="150" align="center">
        <template #default="scope">
          <el-tag v-if="scope.row.is_equipable === '1'" type="success" effect="light">
            Jihozlanadi
          </el-tag>
          <span v-else class="muted">—</span>
        </template>
      </el-table-column>
      <el-table-column label="Holati" width="130" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.is_active === '1' ? 'success' : 'info'" effect="light">
            {{ scope.row.is_active === '1' ? 'Faol' : 'Nofaol' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="" width="115" align="center">
        <template #default="scope">
          <el-button
              type="primary"
              size="small"
              @click="
              $router.push({
                name: 'InitiativeCategoryFormEdit',
                params: { id: scope.row.id },
              })
            "
          >
            <img height="15" src="@/assets/images/icons/edit.svg" alt="action"/>
          </el-button>
          <el-button
              type="danger"
              size="small"
              @click="onClickDelete(scope.row.id)"
          >
            <img height="15" src="@/assets/images/icons/delete.svg" alt="action"/>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span>Jami: {{ totalElements }}</span>
          <el-pagination
              v-model:current-page="currentPage"
              class="pagination"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="sizes, prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
              :page-sizes="[15, 20, 30, 50, 100, 200, 500, 1000]"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.el-button--primary {
  text-decoration: none;
}

.muted {
  color: #909399;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.pagination-wrapper > span {
  color: #0a194e;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>
